import LocalStorageService from '../../../services/LocalStorageService.js';
import country from '../../constants-v2/person/country.js';

export default payload => ({
  id: undefined,
  city: '',
  street: '',
  house_number: '',
  flat_number: '',
  voivodeship: '',
  country: country.POLAND,
  county: '',
  borough: '',
  person: undefined,
  owner: LocalStorageService.get('person')?.id,
  postal_code: '',
  post_office: '',
  ...payload,
});
